/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Progress_Phase_CommittingInputs */

const cs_import_progress_phase_committing = /** @type {(inputs: Import_Progress_Phase_CommittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukládání`)
};

const en_import_progress_phase_committing = /** @type {(inputs: Import_Progress_Phase_CommittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Committing`)
};

/**
* | output |
* | --- |
* | "Committing" |
*
* @param {Import_Progress_Phase_CommittingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_progress_phase_committing = /** @type {((inputs?: Import_Progress_Phase_CommittingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Progress_Phase_CommittingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_progress_phase_committing(inputs)
	return cs_import_progress_phase_committing(inputs)
});